import { createFileRoute } from '@tanstack/react-router';

import { crownQueryClient } from '@/common/api/crownQueryClient';
import { getProviderUserQuery } from '@/features/administrator-panel/provider-view/provider-user-view/api/providerUserViewApi';
import { fullName } from '@/lib/fullName';
import { ProviderUserView } from '@/features/administrator-panel/provider-view/provider-user-view/ProviderUserView.tsx';

export const Route = createFileRoute(
  '/admin/providers/$providerId/users/$userId',
)({
  loader: ({ params }) =>
    crownQueryClient.ensureQueryData(
      getProviderUserQuery(params.providerId, params.userId),
    ),
  head: ({ loaderData }) => ({
    meta: [
      {
        title: loaderData ? fullName(loaderData) : 'Team Member',
      },
    ],
  }),
  component: ProviderUserView,
});
